var map = {
	"./cn/ios.png": "xp05",
	"./en/ios.png": "2H6B",
	"./th/ios.png": "+85N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GDWY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav ^\.\/.*\/ios\.png$
// module id = GDWY
// module chunks = 1